import React, { useEffect, useImperativeHandle, forwardRef } from 'react'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import styles from './contactsInfo.module.scss'
import Icon from 'src/@core/components/icon'
import { useTranslation } from 'src/utils/i18n'

function TemporaryDrawer({ data }, ref) {
  const [state, setState] = React.useState({
    right: false
  })
  const { t } = useTranslation('common')

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setState({ ...state, [anchor]: open })
  }

  function toggleDrawerParent(anchor, open) {
    setState({ ...state, [anchor]: open })
  }

  useImperativeHandle(ref, () => ({
    // 暴露给父组件的方法
    toggleDrawerParent
  }))

  const list = anchor => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 300 }}
      role='presentation'
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className={styles.contactsInfo}>
        <div className={styles.arrow}>
          <Icon icon='mdi:chevron-right' />
        </div>

        <div className={styles.top}>
          <div className={styles.pic}>{data.firstName.charAt(0)}</div>
          <div className={styles.name}>{data.firstName}</div>
        </div>
        <div className={styles.contentBox}>
          <div className={styles.containers}>
            <div className={styles.icon}>
              <Icon icon='mdi:phone-outline' />
            </div>
            <div className={styles.text}>
              <span className={styles.name}>{t('Numbers')}</span>
              <span className={styles.number}>{data.phones instanceof Array ? data.phones[0].field : ''} </span>
            </div>
          </div>
          <div className={styles.containers}>
            <div className={styles.icon}>
              <Icon icon='mdi:email' />
            </div>
            <div className={styles.text}>
              <span className={styles.name}>{t('Email')}</span>
              <span className={styles.number}>
                {data.emailAddresses instanceof Array ? data.emailAddresses[0].field : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )

  return (
    <div>
      <Drawer anchor={'right'} open={state['right']} onClose={toggleDrawer('right', false)}>
        {list('right')}
      </Drawer>
    </div>
  )
}

TemporaryDrawer = forwardRef(TemporaryDrawer)

export default TemporaryDrawer
